export default __webpack_public_path__ + "static/media/logo192x192.303b5a9c.png";